import {inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CookieService} from "../services/cookie.service";

/**
 * Перехватчик, добавляющий заголовок Authorization к HTTP-запросам.
 *
 * Если в куках найден токен, он будет добавлен как Bearer токен,
 * также устанавливается заголовок accept: '*'. Не изменяет логику обработки ответа.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  #cookieService = inject(CookieService)

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.#cookieService.getCookie('auth')
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token,
          accept: '*'
        }
      })
    }
    return next.handle(request);
  }
}
